/**
 * @fileoverview Погодные всплески и разворот прогноза фронта.
 */

import { spawnPlane } from "../plane/spawn";
import type { GameHooks, GameState } from "../state/types";
import { pick, rnd } from "../util/math";

/** Разворот направления фронта (прогноз). */
export function applyFrontForecast(g: GameState, hooks: GameHooks): void {
  if (!g.front) return;
  const f = g.front;
  const was = f.dir > 0 ? "запада" : "востока";
  f.dir *= -1;
  f.forecastBias = rnd(-0.05, 0.28);
  f.speed *= 1.08;
  const now = f.dir > 0 ? "запада" : "востока";
  g.wxName = "Новый прогноз фронта";
  hooks.onWxName?.(g.wxName);
  hooks.toast(
    `НОВЫЙ ПРОГНОЗ: фронт развернулся — было с ${was}, теперь с ${now}. Эта сторона поля заносится сильнее (~+35%). Перестройте уборку.`,
    "wx",
  );
}

/** Случайное погодное событие (без карточки решения). */
export function weatherEvent(g: GameState, hooks: GameHooks): void {
  const list: string[] = ["snow", "cross", "vis", "prio", "front"];
  const k = pick(list);

  if (k === "snow") {
    g.snowBoost = 0.9;
    g.snowBoostT = 22;
    g.wxName = "Сильный снег";
    hooks.toast("УСИЛЕНИЕ СНЕГА — полосы заносит вдвое быстрее", "wx");
  } else if (k === "cross") {
    g.cross = 1;
    g.crossT = 24;
    g.windSpd = rnd(20, 30);
    g.wxName = "Боковой ветер";
    g.windDir =
      g.windDir + (Math.random() < 0.5 ? -1 : 1) * rnd(0.8, 1.3);
    hooks.toast(
      "БОКОВОЙ ВЕТЕР — стрелка красная, пробег +~32%, рысканье на полосе",
      "wx",
    );
  } else if (k === "vis") {
    g.visTarget = 0.4;
    g.visT = 20;
    g.wxName = "Плохая видимость";
    hooks.toast("СНИЖЕНИЕ ВИДИМОСТИ — на поле метель", "wx");
  } else if (k === "front") {
    applyFrontForecast(g, hooks);
  } else {
    spawnPlane(g, hooks, pick(["jet", "cargo"] as const), true);
    g.wxName = "Приоритетный борт";
  }
  if (k !== "front") hooks.onWxName?.(g.wxName);
}
